<template>
  <div class="main-wrapper" id="page-top">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
      <a class="navbar-brand js-scroll-trigger" href="#page-top">
        <span class="d-block d-lg-none">Start Bootstrap</span>
        <span class="d-none d-lg-block">
          <img class="img-fluid img-profile rounded-circle mx-auto mb-2" src="./assets/me.jpg" alt="">
        </span>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#experience">Experience</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#education">Education</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#skills">Skills</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#interests">Interests</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#awards">Awards</a>
          </li> -->
        </ul>
      </div>
    </nav>

    <div class="container-fluid p-0">

      <section class="resume-section p-3 p-lg-5 d-flex d-column" id="about">
        <div class="my-auto">
          <h1 class="mb-0">
            {{name}}
            <span class="text-primary">{{surname}}</span>
          </h1>
          <div class="subheading mb-5">{{address}} · {{phone}} ·
            <a :href="` mailto:${email} `">{{email}}</a>
          </div>
          <p class="mb-5">{{aboutme}}</p>
          <ul class="list-inline list-social-icons mb-0">
            <li class="list-inline-item">
              <a :href="fb" target="_blank">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <!-- <li class="list-inline-item">
              <a :href="tw" target="_blank">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-twitter fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li> -->
            <li class="list-inline-item">
              <a :href="linkedin" target="_blank">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-linkedin fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <li class="list-inline-item">
              <a :href="github" target="_blank">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-github fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="experience">
        <div class="my-auto">
          <h2 class="mb-5">Experience</h2>

          <div class="resume-item d-flex flex-column flex-md-row mb-5" v-for="exp in experience" :key="exp.startDate">
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{exp.title}}</h3>
              <div class="subheading mb-3">{{exp.company}}</div>
              <p>{{exp.description}}</p>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary">{{exp.startDate}} - {{exp.endDate}}</span>
            </div>
          </div>
        </div>

      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="education">
        <div class="my-auto">
          <h2 class="mb-5">Education</h2>

          <div class="resume-item d-flex flex-column flex-md-row mb-5" v-for="educ in education" :key="educ.degree">
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{educ.school}}</h3>
              <div class="subheading mb-3">{{educ.degree}}</div>
              <!-- <div>Computer Science - Web Development Track</div>
              <p>GPA: 3.23</p> -->
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary">{{educ.startDate}} - {{educ.endDate}}</span>
            </div>
          </div>

        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="skills">
        <div class="my-auto">
          <h2 class="mb-5">Skills</h2>

          <div class="subheading mb-3">Programming Languages &amp; Tools</div>
          <ul class="list-inline list-icons">
            <li class="list-inline-item" v-for="skill in skills" :key="skill">
              <i v-bind:class="`devicons devicons-${skill}`"></i>
            </li>
          </ul>

          <div class="subheading mb-3">Workflow</div>
          <ul class="fa-ul mb-0">
            <li>
              <i class="fa-li fa fa-check"></i>
              Javascript &amp; NodeJS dev
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Cross-browser coder
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Mobile friendly
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Native-like dev (cordova & ionic)
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              VueJS lover (this is running on Vue)
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              ReactJS (novice/enthusiast)
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              GraphQL (novice/enthusiast)
            </li>
          </ul>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="interests">
        <div class="my-auto">
          <h2 class="mb-5">Interests</h2>
          <p>Apart from being a web developer I enjoy most of my time being at the beach with my gf capturing sunsets</p>
          <p>Novice surfer</p>
          <p>Agatha Christie's novels lover</p>
          <p>Pizza maker enthusiast, wine taster and hobbyist brewer</p>
        </div>
      </section>

      <!-- <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="awards">
        <div class="my-auto">
          <h2 class="mb-5">Awards &amp; Certifications</h2>
          <ul class="fa-ul mb-0">
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              Google Analytics Certified Developer</li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              Mobile Web Specialist - Google Certification</li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              1<sup>st</sup>
              Place - University of Colorado Boulder - Emerging Tech Competition 2009</li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              1<sup>st</sup>
              Place - University of Colorado Boulder - Adobe Creative Jam 2008 (UI Design Category)</li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              2<sup>nd</sup>
              Place - University of Colorado Boulder - Emerging Tech Competition 2008</li>
            <li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              1<sup>st</sup>
              Place - James Buchanan High School - Hackathon 2006</li>
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              3<sup>rd</sup>
              Place - James Buchanan High School - Hackathon 2005</li>
          </ul>
        </div>
      </section> -->

    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'My portfolio',
      name: 'Oscar',
      surname: 'Garita',
      address: 'Nosara, Guanacaste, Costa Rica.',
      phone: '(506) 8924-5455',
      email: 'oxcargasa@gmail.com',
      fb: 'https://www.facebook.com/ogaritas',
      // tw: '',
      github: 'https://github.com/oxcarga',
      linkedin: 'https://www.linkedin.com/in/ogaritas/',
      aboutme: 'Passionate full stack web developer with 8 years of experience. When not in front of my computer learning stuff, you can find me reading or cooking or taking a walk on the beach (it is pretty relaxing). ',
      experience: [
        {
          title: 'Freelance full stack web developer',
          company: '',
          description: 'I have been working closely on GoBoard and some other smaller projects',
          startDate: 'March 2018',
          endDate: '-'
        },
        {
          title: 'Full stack web developer',
          company: 'WEAR Interactive (Study Edge)',
          description: 'I started an project from scratch called GoBoard (currently running on goboard.com) for which I was required to learn NodeJS (ExpressJS), Canvas (paperJS), AWS (deployments), Cordova (for iOS - mobile), scripting and much more. Also learned Wordpress & Drupal for some internal projects I worked on.',
          startDate: 'March 2014',
          endDate: 'February 2018'
        },
        {
          title: 'Front end web developer',
          company: 'Accenture',
          description: 'Worked closely on a project written on Java for a big car company in a sprint-like basis.',
          startDate: 'October 2013',
          endDate: 'February 2014'
        },
        {
          title: 'Front end web developer',
          company: 'AvVenta Worldwide',
          description: 'Learned most of my vanilla JS skill. We used to maintain currently running sites. New campaigns and products for some big companies.',
          startDate: 'January 2012',
          endDate: 'October 2013'
        },
        {
          title: 'HTML & CSS coder (super junior web dev)',
          company: 'Code My Concept',
          description: 'A PSD to HTML & CSS job. Learned best practices for writting html & css.',
          startDate: 'January 2011',
          endDate: 'June 2011'
        }
      ],
      education: [
        {
          school: 'Internet',
          degree: 'the day-to-day school',
          startDate: 'June 2011',
          endDate: '...'
        },
        {
          school: 'Universidad Fidélitas',
          degree: 'Systems Engineering',
          startDate: 'January 2008',
          endDate: 'April 2011'
        },
        {
          school: 'Liceo Experimental Bilingüe de Pococí',
          degree: 'High school bachelor',
          startDate: 'January 2001',
          endDate: 'Dicember 2005'
        }
      ],
      skills: [
        'html5',
        'css3',
        'javascript', // javascript_badge
        'sass',
        'bootstrap',
        'nodejs',
        'vuejs',
        'firebase',
        // 'websockets',
        // 'react',
        'electronjs',
        'ionic',
        'snap_svg',
        'knockoutjs',
        'handlebars',
        'php',
        'wordpress',
        'codeigniter',
        'drupal'
      ],
      otherTools: [
        'grunt',
        'gulp',
        'npm',
        'paperJS',
        'firebase',
        'atom',
        'bower',
        'docker',
        'git',
        'github',
        'webpack',
        'heroku',
        'docker',
        'vagrant',
        'mongodb',
        'photoshop',
        'trello'
      ]
    }
  },
  mounted () {
    const $ = this.jquery
    this.$nextTick(() => {
      'use strict' // Start of use strict

      // Smooth scrolling using jQuery easing
      $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash)
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
          if (target.length) {
            $('html, body').animate({
              scrollTop: (target.offset().top)
            }, 1000, 'easeInOutExpo')
            return false
          }
        }
      })

      // Closes responsive menu when a scroll trigger link is clicked
      $('.js-scroll-trigger').click(function () {
        $('.navbar-collapse').collapse('hide')
      })

      // Activate scrollspy to add active class to navbar items on scroll
      $('body').scrollspy({
        target: '#sideNav'
      })
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue